import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { IApiError } from '../../../../react-core/Core/ApiError';
import { SippIncome } from '../../../Models/Domains/Valuation/SippIncome';
import { SippDrawdownServiceError } from '../../../Validation/Errors/Account/SippDrawdownServiceError';

declare var IS_RUNNING_IN_APP_POOL;

export class SippIncomeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<SippIncome, IApiError<SippDrawdownServiceError>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Investment/SippIncome/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<SippIncome, IApiError<SippDrawdownServiceError>[]>(url, data);
  }
}

